import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_3 = {
  key: 0,
  class: "p-0 m-0"
}
const _hoisted_4 = { class: "display p-0 m-0" }
const _hoisted_5 = {
  width: "11",
  height: "11",
  class: "m-0 p-0"
}
const _hoisted_6 = {
  key: 0,
  class: "svgScale"
}
const _hoisted_7 = ["stroke"]
const _hoisted_8 = ["stroke"]
const _hoisted_9 = ["stroke"]
const _hoisted_10 = {
  key: 1,
  class: "svgScale"
}
const _hoisted_11 = ["stroke"]
const _hoisted_12 = ["stroke"]
const _hoisted_13 = ["stroke"]
const _hoisted_14 = ["stroke"]
const _hoisted_15 = { class: "display m-0 p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.codes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codesArray, (code, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (code==='S' || code==='s' || code==='~')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(), _createElementBlock("svg", _hoisted_5, [
                    (code==='S' || code==='s')
                      ? (_openBlock(), _createElementBlock("g", _hoisted_6, [
                          _createElementVNode("ellipse", {
                            fill: "none",
                            stroke: _ctx.textColor,
                            "stroke-miterlimit": "10",
                            cx: "6.9",
                            cy: "7.15",
                            rx: "6.36",
                            ry: "6.594"
                          }, null, 8, _hoisted_7),
                          _createElementVNode("line", {
                            fill: "none",
                            stroke: _ctx.textColor,
                            "stroke-miterlimit": "10",
                            x1: "2.379",
                            y1: "2.5",
                            x2: "11.555",
                            y2: "11.677"
                          }, null, 8, _hoisted_8),
                          _createElementVNode("line", {
                            fill: "none",
                            stroke: _ctx.textColor,
                            "stroke-miterlimit": "10",
                            x1: "2.2",
                            y1: "11.67",
                            x2: "11.338",
                            y2: "2.532"
                          }, null, 8, _hoisted_9)
                        ]))
                      : _createCommentVNode("", true),
                    (code==='~')
                      ? (_openBlock(), _createElementBlock("g", _hoisted_10, [
                          _createElementVNode("path", {
                            fill: "none",
                            stroke: _ctx.textColor,
                            "stroke-miterlimit": "10",
                            d: "M0.236,2.345c0,0,2.863-1.72,6.132-1.72 c3.27,0,6.796,1.72,6.796,1.72"
                          }, null, 8, _hoisted_11),
                          _createElementVNode("line", {
                            fill: "none",
                            stroke: _ctx.textColor,
                            "stroke-miterlimit": "10",
                            x1: "4.328",
                            y1: "2.682",
                            x2: "2.453",
                            y2: "11.775"
                          }, null, 8, _hoisted_12),
                          _createElementVNode("line", {
                            fill: "none",
                            stroke: _ctx.textColor,
                            "stroke-miterlimit": "10",
                            x1: "7.328",
                            y1: "2.682",
                            x2: "5.453",
                            y2: "11.775"
                          }, null, 8, _hoisted_13),
                          _createElementVNode("line", {
                            fill: "none",
                            stroke: _ctx.textColor,
                            "stroke-miterlimit": "10",
                            x1: "10.328",
                            y1: "2.682",
                            x2: "8.453",
                            y2: "11.775"
                          }, null, 8, _hoisted_14)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                style: _normalizeStyle({'background-color': _ctx.colors ? _ctx.colors[index] : 'transparent', 'color': _ctx.textColor}),
                class: "p-0 m-0"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.names[index]), 1)
                ])
              ], 4))
        ], 64))
      }), 128))
    ])
  ], 64))
}